import MazPhoneNumberInput from "./_main.vue";

MazPhoneNumberInput.install = (Vue) => {
  Vue.component(MazPhoneNumberInput.name, MazPhoneNumberInput);
};

export default MazPhoneNumberInput;
